import { useContext } from 'react';

import { ArtworkContext } from './ArtworkProvider';

export const useArtworkContext = () => {
  return useContext(ArtworkContext);
};
